import React from 'react';
// ---------------  For Ui ----------------------------------
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import { Redirect } from 'react-router-dom'
// ---------------  For Redux ----------------------------------
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { createProject, createProjectReset } from '../../store/actions/ProjectActions'
import UserPicker from '../custom/UserPicker'
import moment from 'moment'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { checkA, getCollection } from '../../constant'

import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Grid } from '@material-ui/core';



const styles = theme => ({
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
  },
  avatar: {
    margin: theme.spacing,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing,
  },
  submit: {
    marginTop: theme.spacing(3),
  },
});

class CreateProject extends React.Component {

  state = {
    title: this.props.project.title,
    content: '',
    startDateTime: moment().format('Y-MM-DDThh:mm'),
    endDateTime: moment().format('Y-MM-DDThh:mm'),
    manager: null,
    assignee: null
  }

  componentWillReceiveProps() {
    const { project, projectId } = this.props;

    if (projectId) {
      const { title, startDateTime, endDateTime, content, saveError, assignee, manager } = project;
      this.setState({ title, startDateTime, endDateTime, content, saveError, assignee, manager });
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();

    const { content, manager, assignee } = this.state;
    const { project } = this.props;

    if (!content) {
      this.setState({ saveError: 'Please add project description' });
      return;
    }

    if (!manager) {
      this.setState({ saveError: 'Please select project manager' });
      return;
    }

    if (!assignee || (assignee && !assignee.length)) {
      this.setState({ saveError: 'Please choose a assignee' });
      return;
    }

    const assigneeIds = [manager.id]
    assignee.forEach(user => {
      assigneeIds.push(user.id)
    });

    const data = { ...this.state, assigneeIds, id: (project && project.projectId) || null };
    delete data.saveError;

    this.props.createProject(data);
  }

  handleEditorChange = (html) => {
    this.setState({ content: html })
  }


  render() {
    const { classes, auth, projectData, history, createProjectReset, profile, project: projectPre, projectId } = this.props;
    const { project, error } = projectData;

    const { title, startDateTime, endDateTime, content, saveError } = this.state;

    if (project) {
      history.push('/project/' + project.id + '/1');
      createProjectReset();
      return null;
    }

    if (!auth.uid) return <Redirect to='/signin' />

    if (profile && checkA(profile) && !this.state.organization) {
      this.setState({ organization: profile.organization })
    }

    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout} style={{ maxWidth: '80%', margin: 'auto' }}>
          <Paper className={classes.paper} square={false}>
            <Typography variant="h4">Create new project</Typography>
            <form className={classes.form} onSubmit={this.handleSubmit} >

              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="title">Title</InputLabel>
                <Input
                  onChange={this.handleChange}
                  value={title}
                  id="title" name="title" autoComplete="text" />
              </FormControl>

              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="title">Start Date Time</InputLabel>
                <Input
                  onChange={this.handleChange}
                  value={startDateTime}
                  id="startDateTime" name="startDateTime" type="datetime-local" />
              </FormControl>

              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="title">End Date Time</InputLabel>
                <Input
                  onChange={this.handleChange}
                  value={endDateTime}
                  id="endDateTime" name="endDateTime" type="datetime-local" />
              </FormControl>

              <Grid container>
                <Grid xs={6} style={{paddingRight: 10}}>
                  <FormControl margin="normal" required fullWidth>
                    <UserPicker defaultValue={projectPre && projectPre.manager} onChange={(manager) => { this.setState({ manager }) }} label="Project Manager" />
                  </FormControl>
                </Grid>
                <Grid xs={6} style={{paddingLeft: 10}}>
                  <FormControl margin="normal" required fullWidth>
                    <UserPicker defaultValue={projectPre && projectPre.assignee} onChange={(assignee) => { this.setState({ assignee }) }} multiple label="Assign To" />
                  </FormControl>
                </Grid>
              </Grid>


              <div style={{ padding: 10 }}></div>

              {/* <ReactQuill defaultValue={projectPre && projectPre.content} theme="snow" onChange={this.handleEditorChange} /> */}

              <CKEditor
                editor={ClassicEditor}
                data={projectPre && projectPre.content}
                onInit={editor => {
                  // You can store the "editor" and use when it is needed.
                  console.log('Editor is ready to use!', editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  // console.log( { event, editor, data } );
                  this.handleEditorChange(data);
                }}
                onBlur={(event, editor) => {
                  // console.log( 'Blur.', editor );
                }}
                onFocus={(event, editor) => {
                  // console.log( 'Focus.', editor );
                }}
              />


              {error || saveError ? <div>  <br /> <Typography component="p" color="error" align="center"> {(error && error.message) || saveError}</Typography> </div> : null}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                {projectId ? 'Update Project' : 'Create Project'}
              </Button>
            </form>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}
CreateProject.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => {
  return {
    createProject: (project) => dispatch(createProject(project)),
    createProjectReset: () => dispatch(createProjectReset())
  }
}

const mapStateToProps = (state, ownProps) => {
  const projectId = ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.projectId
  const projects = state.firestore.data[getCollection(state.firebase.profile, 'projects')];

  const project = projects ? projects[projectId] : null

  console.log("project : ", project)

  return {
    auth: state.firebase.auth,
    projectData: state.project,
    project: { ...project, projectId },
    profile: state.firebase.profile,
    projectId
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    if (props.projectId) {
      return [
        {
          collection: getCollection(props.profile, 'projects'),
          doc: props.projectId,
        }
      ]
    } else {
      return [];
    }
  })
)(withStyles(styles)(CreateProject));